export default {
    performer: 'Исполнитель',
    title: 'Название доступности',
    date: 'Дата',
    offers: 'Услуги',
}
